import { FormControl, FormHelperText, FormLabel, Grid, Switch } from '@mui/material';
import _get from 'lodash/get';
import PropTypes from 'prop-types';
import React from 'react';
import { Controller } from 'react-hook-form';

const SwitchField = ({
  name,
  control,
  formState,
  error,
  label,
  inputProps,
  helperText,
  labelStyle,
  layout = {},
  ...props
}) => {
  const { errors = {} } = formState;

  return (
    <Controller
      name={name}
      control={control}
      {...props}
      render={({ field }) => (
        <FormControl fullWidth error={error || !!_get(errors, `${name}.message`)}>
          <Grid container {...layout.grid}>
            <Grid item {...layout.label}>
              {!!label && <FormLabel>{label}</FormLabel>}
            </Grid>
            <Grid item {...layout.input} style={{ paddingTop: '8px' }}>
              <Switch color="primary" edge="start" defaultValue={false} {...field} checked={field.value} />
            </Grid>
            <Grid item xs={12}>
              <FormHelperText>{helperText || _get(errors, `${name}.message`)}</FormHelperText>
            </Grid>
          </Grid>
        </FormControl>
      )}
    />
  );
};

SwitchField.propTypes = {
  name: PropTypes.string.isRequired,
  control: PropTypes.object.isRequired,
  formState: PropTypes.object.isRequired,

  error: PropTypes.bool,
  required: PropTypes.bool,
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,

  inputProps: PropTypes.object,
  defaultValue: PropTypes.bool,
  type: PropTypes.string,
  label: PropTypes.string,
  margin: PropTypes.string,
  variant: PropTypes.string,
  layout: PropTypes.object,
  helperText: PropTypes.string,
  autoComplete: PropTypes.string,
  labelStyle: PropTypes.object
};

SwitchField.defaultProps = {
  error: false,
  required: false,
  autoFocus: false,
  disabled: false,

  inputProps: null,
  defaultValue: false,
  type: '',
  label: '',
  margin: 'normal',
  variant: 'outlined',
  layout: {
    grid: {
      my: 1
    },
    label: {
      xs: 12
    },
    input: {
      xs: 12
    }
  },
  helperText: '',
  autoComplete: ''
};

export default SwitchField;
